import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import SoompiApp from 'scripts/components/SoompiApp'
import SoompiEmbed from 'scripts/components/SoompiEmbed'
import cookie from 'react-cookies'
import ClientErrors from 'scripts/lib/ClientErrors'
import Loadable from 'react-loadable'
import locale from 'shared/i18n/react'
import Constants from 'scripts/base/Constants'
import {getMatchedRoute} from 'scripts/lib/utils'
import {routes} from 'scripts/routes'

import FontFaceObserver from 'fontfaceobserver'
import { Provider } from 'scripts/store'
import '../scss/style.scss'
import '../../favicon.ico'
import '../../ads.txt'
import '../../BingSiteAuth.xml'

import '@viki-ui/lazy-load'

const oswald = new FontFaceObserver('oswald')
const lato = new FontFaceObserver('lato')
const isFontLoaded = window.fl
const path = window.location.pathname
const { match } = getMatchedRoute({routes, path})

if (match && match.params['lang']) {
  locale.setLanguage(match.params['lang'])
} else {
  locale.setLanguage(Constants.DefaultLang)
}

function setFontsAsLoadedHTML() {
  document.documentElement.className += ' fonts-loaded'
  const expires = new Date()
  expires.setDate(expires.getDate() + 7)
  cookie.save('fontsLoaded', true, { path: '/', secure: false, httpOnly: false, expires: expires })
}

if (isFontLoaded === 'true') {
  setFontsAsLoadedHTML()
} else {
  Promise.all([
    oswald.load(),
    lato.load()
  ]).then(function() {
    setFontsAsLoadedHTML()
  }, function(error) {
    ClientErrors({
      message: 'font is not available at this time, so we are using fallback fonts instead',
      error: error
    })
  })
}

const mountNode = document.getElementById('app')
const isEmbed = match.path === Constants.Routes.EMBED
const App = () => isEmbed ? <SoompiEmbed locale={locale}/> : <SoompiApp locale={locale}/>

Loadable.preloadReady().then(() => {
  ReactDOM.hydrate(
    <Provider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>,
    mountNode
  )
})



// WEBPACK FOOTER //
// ./assets/js/client.jsx